<div class="loader-container" *ngIf="display">
  <div class="spinner">
    <div></div>
    <div></div>
  </div>
  <p role="alert" aria-live="assertive">Loading...</p>
</div>
